// DonatePage.jsx — standalone, shareable version of the Navigator's Donate
// tab. Renders the same DonateContent sections the tab uses, wrapped in
// public-page chrome (PageTaskbar + a maximized chrome window) so /donate
// can be linked directly without booting the desktop.
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PageTaskbar from "../../components/ui/Taskbar/PageTaskbar";
import OSIcon32 from "../../components/icons/OSIcon32";
import DonateContent from "../../components/donate/DonateContent";
import { setShareMeta } from "../../helpers/shareMeta";

export default function DonatePage() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Route-specific link-preview card for shares of /donate.
  useEffect(() => setShareMeta({
    image: "https://www.goodneighbor.fund/assets/og/donate.png",
    url: "https://www.goodneighbor.fund/donate",
  }), []);

  const handleClose = () => {
    try {
      sessionStorage.setItem("gnf-has-booted", "1");
    } catch {}
    try {
      navigate("/");
    } catch (error) {
      console.error("Navigation error:", error);
      window.location.href = "/";
    }
  };

  return (
    <div className="mb-page" style={{
      minHeight: "100vh",
      overflowY: "auto",
      WebkitOverflowScrolling: "touch",
      display: "flex",
      flexDirection: "column",
      padding: "10px",
      paddingBottom: "calc(80px + env(safe-area-inset-bottom))",
      boxSizing: "border-box",
      background: "transparent",
    }}>
      <PageTaskbar windowLabel="Donate to GNF" windowIcon="donate" />
      <div style={{
        background: "var(--chrome-face)",
        border: "2px solid",
        borderColor: "var(--bevel-raised)",
        boxShadow: "var(--shadow-raised), var(--window-drop)",
        display: "flex",
        flexDirection: "column",
        margin: "0 auto",
        width: "100%",
        maxWidth: 1100,
      }}>
        <div className="win95-titlebar" style={{ cursor: "default", flexShrink: 0 }}>
          <OSIcon32 kind="donate" size={15} className="win95-titlebar__icon" />
          <span className="win95-titlebar__label">Donate to GNF</span>
          <div className="win95-titlebar__btns">
            <button
              type="button"
              className="win95-btn-sys win95-close-btn"
              onClick={handleClose}
              aria-label="Close"
            >
              ✕
            </button>
          </div>
        </div>
        <main className="mb-content" style={{ background: "var(--mb-chalk)" }}>
          <DonateContent />
        </main>
      </div>
    </div>
  );
}
